import { Stack, styled } from 'shell/components';

const ChatPromptFrame = ({ children }) => (
    <PromptEntrance>
        <PromptEntranceInner>{children}</PromptEntranceInner>
    </PromptEntrance>
);

const PromptEntrance = styled(Stack)(({ theme }) => ({
    display: 'grid',
    gridTemplateRows: '1fr',
    marginTop: theme.spacing(2),
    overflow: 'visible',
    width: '95%',
    animation: 'chat-prompt-reveal 320ms cubic-bezier(0.2, 0, 0, 1)',

    '@keyframes chat-prompt-reveal': {
        '0%': {
            gridTemplateRows: '0fr',
            marginTop: 0,
            overflow: 'hidden',
        },
        '99%': {
            overflow: 'hidden',
        },
        '100%': {
            gridTemplateRows: '1fr',
            marginTop: theme.spacing(2),
            overflow: 'visible',
        },
    },
}));

const PromptEntranceInner = styled(Stack)(() => ({
    minHeight: 0,
    overflow: 'visible',
    transformOrigin: 'top left',
    animation: 'chat-prompt-enter 320ms cubic-bezier(0.2, 0, 0, 1)',

    '@keyframes chat-prompt-enter': {
        '0%': {
            opacity: 0,
            transform: 'translateY(-8px) scale(0.985)',
            overflow: 'hidden',
        },
        '60%': {
            opacity: 1,
        },
        '99%': { overflow: 'hidden' },
        '100%': {
            opacity: 1,
            transform: 'translateY(0) scale(1)',
            overflow: 'visible',
        },
    },
}));

export default ChatPromptFrame;
